import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DelfiComponentsLibraryModule } from '@mare-common/ngx-delfi-components';
import { ApiWpService } from '@mare-common/ngx-mare-auth';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { PlatformApiWpService } from '../services/platform-apiwp.service';
import { TokenService } from '../services/token.service';
import { ChartConfigService } from '../services/chart-config.service';
import { WebSolveupLibraryService } from '@mare-common/web-solveup-library';
import { EventData, EventInteractionService } from '@mare-common/ngx-mare-common';
import { HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CommonConfig } from '../shared/common-config/common-config';
import { take } from 'rxjs';
import { ProductsRelatedComponent } from '../products-related/products-related.component';
import { Platform } from '@angular/cdk/platform';
import { MediaMatcher } from '@angular/cdk/layout';
import { Router } from '@angular/router';

@Component({
  selector: 'page-marketplace',
  standalone: true,
  imports: [CommonModule,
    DelfiComponentsLibraryModule,
    TranslateModule,
    SharedModule,
    MatButtonModule,
    ProductsRelatedComponent,
  ],
  templateUrl: './marketplace.component.html',
  styleUrls: ['./marketplace.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class MarketplaceComponent {
  serviceEndpoint: string = '/wp-json';
  firstTimeInPagePrefix = 'Benvenuto'
  pagetitle: string = 'Marketplace';
  showTestButtons: any;
  checkoutRedirect: boolean = false;



  isMobile$ = signal<boolean>(false);
  constructor(
    private translate: TranslateService,
    private platformApiWpService: PlatformApiWpService,
    private tokenService: TokenService,
    private chartConfigService: ChartConfigService,
    private webSolveupLibraryService: WebSolveupLibraryService,
    private eventInteractionService: EventInteractionService,
    private configService: CommonConfig,
    private media: MediaMatcher,
    private platform: Platform,
    private router: Router
  ) {
    const env: any = environment;
    this.showTestButtons = env['showTestButtons'] ? env['showTestButtons'] : false;
    this.isMobile$.set(this.platform.ANDROID || this.platform.IOS || this.media.matchMedia('(max-width: ' + this.configService.getMobileBreakpoint() + 'px)').matches);
    this.eventInteractionService.getObservable().subscribe((event: EventData) => {
      console.log('event', event);
      switch (event.event) {
        case 'clickedProduct':
            console.log('event.data', event.data);
            this.router.navigate([`${environment.routingBasePath}/product/${event.data.sku}`]);
            break;
        default:
          break;
      }
  })
  
  }
  ngOnInit(): void {
    this.translate.get('Marketplace').pipe(take(1)).subscribe((res: any) => {
      this.pagetitle = res;
    });
    // this.makeCheckWithInterval('07784980638')
  }

  onProductClicked(event: any) {
    console.log(event);
  }

  makeCheckWithInterval(piva: string) {

    this.platformApiWpService.getRequest('/msc/v1/report/check?piva=' + piva).then((sub: any) => {
      const subs = sub.subscribe((response: any) => {
        console.log(response);
        if (response.status === 'ok' && response.payload == 'completed') {
          this.downloadReport();
        } else {
          setTimeout(() => {
            this.makeCheckWithInterval(piva);
          }, 5000);
        }
        subs.unsubscribe();
      });
    })

    // const checkInterval = setInterval(() => {
    //   this.platformApiWpService.getRequest('/msc/v1//report/check?piva=' + piva ).then((sub: any) => {
    //     sub.subscribe((response: any) => {
    //       console.log(response);
    //       if(response.status === 'ok' && response.payload == 'completed') {
    //         clearInterval(checkInterval);
    //         this.downloadReport();
    //       }
    //     });
    //   })
    // }, 5000)
  }

  downloadReport() {
    const url = this.platformApiWpService.getBaseUrl() + '/msc/v1/report/download';

    this.platformApiWpService.setHeaders().then((headers: HttpHeaders) => {
      const options: {
        headers?: HttpHeaders | {
          [header: string]: string | string[];
        };
        context?: HttpContext;
        observe?: 'body' | 'events' | 'response';
        params?: HttpParams | {
          [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType?: 'json' | 'arraybuffer' | 'blob' | 'text';
        withCredentials?: boolean;
      } = {
        headers: headers,
        responseType: 'blob'
      }
      this.platformApiWpService.getRawRequest(url, options, false, true).subscribe((response: any) => {
        let blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
      })
    })

    this.platformApiWpService.getRequest('/msc/v1/report/download').then((sub: any) => {
      const subs = sub.subscribe((response: any) => {
        console.log(response);
        subs.unsubscribe();
      });
    })
  }

  getReport() {
    const piva = '07784980638';
    const requestReport = false;
    if (requestReport) {
      const url = '/msc/v1/report/request' + '?piva=' + piva;
      this.platformApiWpService.getRequest(url).then((sub: any) => {
        const subs = sub.subscribe((response: any) => {
          console.log(response);
          this.makeCheckWithInterval(piva);
          subs.unsubscribe();
        });
      })
      return;
    }

    console.log("getReport");
    this.platformApiWpService.postRequest('/msc/v1/addToCart', {
      sku: 'report-digitale',
      variationSku: 'report-digitale-medium',
      params: {
        piva: '07784980638',
        thwepof_options: {
          piva: {
            name: 'piva',
            value: '07784980638',
            type: "inputtext",
            label: 'Partita IVA',
            options: ''
          }
        }
      }
    }).then((sub: any) => {
      sub.subscribe((response: any) => {
        console.log(response);
      });
    });
    // this.makeCheckWithInterval('07784980638')
  }

  makeCheckWithInterval_tocheck(piva: string) {

    this.platformApiWpService.getRequest('/msc/v1/report/check?piva=' + piva).then((sub: any) => {
      const subs = sub.subscribe((response: any) => {
        console.log(response);
        if (response.status === 'ok' && response.payload == 'completed') {
          this.downloadReport();
        } else {
          setTimeout(() => {
            this.makeCheckWithInterval(piva);
          }, 5000);
        }
        subs.unsubscribe();
      });
    })

    // const checkInterval = setInterval(() => {
    //   this.platformApiWpService.getRequest('/msc/v1//report/check?piva=' + piva ).then((sub: any) => {
    //     sub.subscribe((response: any) => {
    //       console.log(response);
    //       if(response.status === 'ok' && response.payload == 'completed') {
    //         clearInterval(checkInterval);
    //         this.downloadReport();
    //       }
    //     });
    //   })
    // }, 5000)
  }



  getCart() {
    console.log("getCart");
    this.platformApiWpService.getRequest('/msc/v1/getCart').then((sub: any) => {
      sub.subscribe((response: any) => {
        console.log(response);
      });
    });
  }

  addNewOrder() {

    const data = {
      'products': [{
        // 'productId': 11300,
        'productSku': 'report-digitale',
        'variationSku': 'report-digitale-medium'
        // 'price': 1,
        // 'num_report': 6
      }
      ],
      // 'customer_id': 8,
      // 'company_id': 11280,
      'orderType': 'delfi report',
      // 'price': 1
    }

    this.platformApiWpService.postRequest('/msc/v1/checkout', data).then((sub: any) => {
      sub.subscribe((response: any) => {
        console.log(response);
      });
    });

  }

  checkout() {
    if (this.checkoutRedirect) {
      console.log("checkout");
      let access_token = this.tokenService.getAccessToken();
      // const url = 'https://servicecompany.maredigital.it/sso?access_token=' + access_token + "&redirect_to=https://servicecompany.maredigital.it/carrello"
      // const url = 'https://servicecompany.maredigital.it/sso?access_token=' + access_token + "&redirect_to=https://servicecompany.maredigital.it/pagamento/"
      const url = this.configService.getBaseUrl() + '/sso?access_token=' + access_token + "&redirect_to=https://servicecompany.maredigital.it/pagamento/&scope=checkout"
      console.log(url, access_token);
      window.open(url, '_blank')
    } else {
      this.platformApiWpService.postRequest('/msc/v1/wccheckout', {}).then((sub: any) => {
        sub.subscribe((response: any) => {
          console.log(response);
        });
      });
    }

  }

  chartData() {
    console.log('chartData')

    const piva = '07784980638';
    const reportValue = 1000;

    // this.platformApiWpService.postRequest('/msc/v1/requestReportContact', { reportValue: reportValue }).then((sub) => {
    //   sub.subscribe((ret) => {
    //     console.log(ret);
    //     this.webSolveupLibraryService.getIsAvailableOperators().then((isAvailable: boolean) => {
    //       console.log('is available', isAvailable)
    //       if (isAvailable) {
    //         this.eventInteractionService.publishData({
    //           event: 'openAssistanceFormPlatform',
    //           data: {
    //             'piva': piva,
    //             'prezzo': reportValue
    //           }
    //         })
    //       } else {
    //         // TODO deve aprire il form di contatto
    //       }
    //     })
    //   })
    // })

    // questo usa il polling
    this.platformApiWpService.getRequest('/msc/v1/checkRequestedUrl').then((sub) => {
      sub.subscribe((ret) => {
        console.log(ret);
      })
    })


    // this.webSolveupLibraryService.getIsAvailableOperators().then((isAvailable: boolean) => {
    //   console.log('is available', isAvailable)
    //   if(isAvailable) {
    //     this.eventInteractionService.publishData({
    //       event: 'openAssistanceFormPlatform',
    //       data: {
    //         'piva': '07784980638',
    //         'prezzo': 1000
    //       }
    //     })
    //   }
    // })

    let ateco = "62.01";
    // const data = this.chartConfigService.retrieveFatturatoUtileMercato(ateco);
    const data = this.chartConfigService.retrieveFatturatoEbitdaAcquisti("6201");
    // const data = this.chartConfigService.retrieveInnovationIndex("6201");


    this.chartConfigService.makeChartDataApiCall(data).then((sub: any) => {
      sub.subscribe((response: any) => {
        console.log(response);
      });
    })

  }

  envelope() {
    this.platformApiWpService.postRequest('/msc/v1/searchProducts?_envelope', {}).then((sub: any) => {
      sub.subscribe((response: any) => {
        console.log(response);
        let queries: any[] = response.qm.db_queries.dbs.$wpdb.queries;
        queries = queries.sort((a: any, b: any) => {
          if (a.time > b.time) {
            return -1;
          }
          if (a.time < b.time) {
            return 1;
          }
          return 0;
        })
        console.log(queries);
      })
    })
    this.platformApiWpService.postRequest('/msc/v1/searchProducts', {}).then((sub: any) => {
      sub.subscribe((response: any) => {
        console.log(response);
      })
    })
  }

}
